module.exports = __webpack_public_path__ + "static/move_heatmap_dashboard-70592c6f9747432f79409ecbd4fa419b.jpg";